import { render, staticRenderFns } from "./CountryOverviewDetailsMerkTable.vue?vue&type=template&id=7272c8f8&"
import script from "./CountryOverviewDetailsMerkTable.vue?vue&type=script&lang=js&"
export * from "./CountryOverviewDetailsMerkTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports